import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useSelectedStore } from '../stores';
import { useMyRole } from './useMyRole';
import { savePendingRedirect } from './usePendingRedirect';

export enum GuardScope {
    Workspace = 'workspace',
    Project = 'project',
}

export const useAccessGuard = (scope: GuardScope, memberOnly?: boolean) => {
    const { workspace: myWorkspace, project: myProject } = useSelectedStore();
    const navigate = useNavigate();
    const location = useLocation();
    const myRole = useMyRole();

    useEffect(() => {
        const currentUrl = location.pathname + location.search;

        // Don't save /w as pending redirect - it's the fallback destination
        const shouldSaveRedirect = currentUrl !== '/w' && !currentUrl.startsWith('/w/');

        if (scope === GuardScope.Workspace && !myWorkspace) {
            if (shouldSaveRedirect) {
                savePendingRedirect(currentUrl);
            }
            navigate('/w', { replace: true });
            return;
        }
        if (scope === GuardScope.Project && (!myWorkspace || !myProject)) {
            if (shouldSaveRedirect) {
                savePendingRedirect(currentUrl);
            }
            navigate('/w', { replace: true });
            return;
        }

        if (memberOnly && myRole > 1) {
            navigate('/w', { replace: true });
        }
    }, [myWorkspace, myProject, navigate, scope, myRole, location.pathname, location.search]);
};
